module.exports = __webpack_public_path__ + "static/media/bg2.39087754.jpg";